// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"d30467de","164":"af7dd56e","254":"11c8c4fd","301":"03d829b7","444":"82b8a4fb","453":"31a33fe4","721":"a5e7fbe1"}[chunkId] + ".chunk.js";
};